import { Dispatch, SetStateAction } from 'react';
import { DrawerContainer } from '../../../../components/Drawer/DrawerContainer';
import { SRTInformationDrawer } from '../SRTInformationDrawer';
import { SVCCVincularDrawer } from '../SVCCVincularDrawer';

export const PRESENTATIONS_DRAWER_ACTION_VALUES = {
    SRT_INFORMATION: 'srt-information',
    SVCC_VINCULAR: 'svcc-vincular'
};

export type PresentationsDrawerAction =
    (typeof PRESENTATIONS_DRAWER_ACTION_VALUES)[keyof typeof PRESENTATIONS_DRAWER_ACTION_VALUES];

interface DrawerManagerProps {
    open: PresentationsDrawerAction | null;
    setOpen: Dispatch<SetStateAction<PresentationsDrawerAction | null>>;
    closeDrawer: () => void;
    selected: any | null;
    translate: (key: string) => string;
    handleSendCarcinogenicReportToSRT: () => Promise<void>;
    isSendingCarcinogenicReportToSRT: boolean
}

const DrawerManager = ({
    open,
    setOpen,
    closeDrawer,
    selected,
    translate,
    handleSendCarcinogenicReportToSRT,
    isSendingCarcinogenicReportToSRT
}: DrawerManagerProps) => {
    const DrawerInputManager = () => {
        switch (open) {
            case PRESENTATIONS_DRAWER_ACTION_VALUES.SRT_INFORMATION:
                return (
                    <SRTInformationDrawer
                        handleCloseDrawer={closeDrawer}
                        selected={selected}
                        translate={translate}
                        handleSendCarcinogenicReportToSRT={handleSendCarcinogenicReportToSRT}
                        isSendingCarcinogenicReportToSRT={isSendingCarcinogenicReportToSRT}
                    />
                );

            case PRESENTATIONS_DRAWER_ACTION_VALUES.SVCC_VINCULAR:
                return (
                    <SVCCVincularDrawer
                        handleCloseDrawer={closeDrawer}
                        translate={translate}
                    />
                );

            default:
                return <></>;
        }
    };

    return (
        <DrawerContainer setOpen={setOpen} open={open} customWidth={550}>
            <DrawerInputManager />
        </DrawerContainer>
    );
};

export default DrawerManager;
